document.addEventListener('DOMContentLoaded', function() {

  // ── Smooth image swap helper ──────────────────────────────────────────
  // Fades the main gallery image out, swaps the src, then fades back in.
  function swapMainImage(imageUrl, altText) {
    const mainImage = document.querySelector('.gallery .plate img');
    if (!mainImage || !imageUrl) return;

    // Start downloading the new image immediately while the fade-out plays
    const preload = new Image();
    preload.src = imageUrl;

    mainImage.classList.add('is-swapping');
    setTimeout(function() {
      // Clear onload first to prevent old events firing
      mainImage.onload = null;
      mainImage.src = imageUrl;
      mainImage.srcset = '';
      mainImage.alt = altText || '';
      
      if (mainImage.complete) {
        mainImage.classList.remove('is-swapping');
      } else {
        mainImage.onload = function() {
          mainImage.classList.remove('is-swapping');
          mainImage.onload = null;
        };
        // Much longer safety fallback
        setTimeout(function() { mainImage.classList.remove('is-swapping'); }, 3000);
      }
    }, 100); // matches the new faster CSS opacity transition duration
  }

  // ── Color persistence via URL ─────────────────────────────────────────
  // Updates all size-switcher links to carry the currently selected colour
  // so navigating Cabin → Medium keeps your colour choice.
  function updateSizeLinksWithColor(colorTitle) {
    document.querySelectorAll('[data-size-group] a.size').forEach(function(link) {
      var url = new URL(link.href, window.location.origin);
      url.searchParams.set('color', colorTitle);
      link.href = url.toString();
    });
  }

  // ── selectVariant ─────────────────────────────────────────────────────
  function selectVariant(variantId, imageUrl, altText, colorName, imageId) {
    // Swap main gallery image with fade
    swapMainImage(imageUrl, altText || colorName);

    // Filter the photo strip down to just this colour's photos
    var thumbStrip = document.querySelector('[data-thumb-strip]');
    if (thumbStrip && colorName) {
      thumbStrip.querySelectorAll('.thumb[data-image-id]').forEach(function(thumb) {
        var thumbColor = thumb.getAttribute('data-color');
        var matchesColor = !thumbColor || thumbColor === colorName;
        thumb.hidden = !matchesColor;
        thumb.setAttribute('aria-checked', matchesColor && thumb.getAttribute('data-image-id') === imageId ? 'true' : 'false');
      });
    } else if (imageId) {
      document.querySelectorAll('.thumb[data-image-id]').forEach(function(thumb) {
        thumb.setAttribute('aria-checked', thumb.getAttribute('data-image-id') === imageId ? 'true' : 'false');
      });
    }

    // Sync every swatch group on the page to this variant
    document.querySelectorAll('[data-swatch-group]').forEach(function(group) {
      var matching = group.querySelector('.sw[data-variant-id="' + variantId + '"]');
      if (!matching) return;

      group.querySelectorAll('.sw').forEach(function(sw) { sw.setAttribute('aria-checked', 'false'); });
      matching.setAttribute('aria-checked', 'true');

      var plate = group.querySelector('.plate img');
      if (plate && imageUrl) {
        plate.src = imageUrl;
        plate.alt = altText || colorName || '';
      }

      var nameLabel = group.querySelector('[data-swatch-name]');
      if (nameLabel && colorName) {
        nameLabel.textContent = colorName;
      }
    });

    // Update the variant radio input used for add-to-cart
    var variantInput = document.querySelector('input[name="id"][value="' + variantId + '"]');
    if (variantInput) {
      variantInput.checked = true;
      document.dispatchEvent(new CustomEvent('variant-change', { detail: { variantId: variantId } }));
    }

    // Update size-switcher links so navigating to another size keeps this colour
    var activeSwatch = document.querySelector('.sw[data-variant-id="' + variantId + '"]');
    if (activeSwatch) {
      var variantTitle = activeSwatch.getAttribute('title') || activeSwatch.getAttribute('data-color') || '';
      // Map display names back to variant titles for URL persistence
      var titleMap = { 'Ivory Black': 'Black', 'Salmon Pink': 'Pink', 'Cosmic Blue': 'Blue', 'Charcoal Grey': 'Grey' };
      var shortTitle = titleMap[variantTitle] || variantTitle;
      updateSizeLinksWithColor(shortTitle);
    }
  }

  // ── Color swatch click handler ────────────────────────────────────────
  document.querySelectorAll('.sw[data-color]').forEach(function(swatch) {
    swatch.addEventListener('click', function(e) {
      e.preventDefault();

      var colorValue = this.getAttribute('data-color');
      var container = this.closest('[data-swatch-group]');
      if (!container) return;

      container.querySelectorAll('.sw').forEach(function(sw) { sw.setAttribute('aria-checked', 'false'); });
      this.setAttribute('aria-checked', 'true');

      var imageUrl = this.getAttribute('data-image');
      var altText = this.getAttribute('data-alt') || colorValue;

      // Update the card / plate image (works on homepage cards + PDP)
      var plate = container.querySelector('.plate img');
      if (plate && imageUrl) {
        // Start downloading immediately
        var preload = new Image();
        preload.src = imageUrl;

        plate.classList.add('is-swapping');
        setTimeout(function() {
          plate.onload = null;
          plate.src = imageUrl;
          plate.srcset = '';
          plate.alt = altText;
          
          if (plate.complete) {
            plate.classList.remove('is-swapping');
          } else {
            plate.onload = function() { plate.classList.remove('is-swapping'); plate.onload = null; };
            setTimeout(function() { plate.classList.remove('is-swapping'); }, 3000);
          }
        }, 100);
      }

      // Update the colour name label
      var nameLabel = container.querySelector('[data-swatch-name]');
      if (nameLabel) {
        nameLabel.textContent = colorValue;
      }

      // Update the hidden add-to-cart form input (for homepage quick-add)
      var variantId = this.getAttribute('data-variant-id');
      if (variantId) {
        var card = container.closest('.card') || container.closest('article');
        if (card) {
          var hiddenInput = card.querySelector('input[name="id"]');
          if (hiddenInput) hiddenInput.value = variantId;

          // Update card product links to carry the colour to the PDP
          var titleMap = { 'Ivory Black': 'Black', 'Salmon Pink': 'Pink', 'Cosmic Blue': 'Blue', 'Charcoal Grey': 'Grey' };
          var shortColor = titleMap[colorValue] || colorValue;
          card.querySelectorAll('a[href*="/products/"]').forEach(function(link) {
            var url = new URL(link.href, window.location.origin);
            url.searchParams.set('color', shortColor);
            link.href = url.toString();
          });
        }

        var imageId = this.getAttribute('data-image-id');
        
        // Only run the global PDP variant sync if this swatch is NOT on a product card.
        // This prevents cards in a collection grid from hijacking the main page or syncing together.
        if (!card) {
          selectVariant(variantId, imageUrl, altText, colorValue, imageId);
        }
      }

      // Update the price if the swatch has a data-price attribute
      var price = this.getAttribute('data-price');
      if (price) {
        var priceElement = document.querySelector('.pdp-price');
        var satcPrice = document.querySelector('.satc-price'); // Sticky add to cart price
        var btnElement = document.querySelector('.pdp-content .btn'); // Main add to cart button
        if (priceElement) priceElement.textContent = price;
        if (satcPrice) satcPrice.textContent = price;
        if (btnElement && btnElement.innerHTML.includes('&middot;')) {
          var btnText = btnElement.innerHTML.split('&middot;')[0];
          btnElement.innerHTML = btnText + '&middot; ' + price;
        }
      }
    });
  });

  // ── Size selector functionality ───────────────────────────────────────
  document.querySelectorAll('.size[data-variant-id]').forEach(function(button) {
    button.addEventListener('click', function() {
      var variantId = this.getAttribute('data-variant-id');
      var parent = this.closest('[data-size-group]');

      if (parent) {
        parent.querySelectorAll('.size').forEach(function(s) { s.setAttribute('aria-checked', 'false'); });
      }
      this.setAttribute('aria-checked', 'true');

      var price = this.getAttribute('data-price');
      if (price) {
        var priceElement = document.querySelector('.pdp-price');
        if (priceElement) {
          priceElement.textContent = price;
        }
      }

      var variantInput = document.querySelector('input[name="id"][value="' + variantId + '"]');
      if (variantInput) {
        variantInput.checked = true;
      }
    });
  });

  // ── Photo strip thumbnail click ───────────────────────────────────────
  document.querySelectorAll('.thumb[data-image-id]').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var imageId = this.getAttribute('data-image-id');
      var imageUrl = this.getAttribute('data-image');
      var altText = this.getAttribute('data-alt');

      // Smooth-swap the main image
      swapMainImage(imageUrl, altText);

      document.querySelectorAll('.thumb[data-image-id]').forEach(function(t) {
        t.setAttribute('aria-checked', t === thumb ? 'true' : 'false');
      });

      // If this photo belongs to a colour variant, keep the swatch selection in sync
      var matchingSwatch = document.querySelector('.sw[data-image-id="' + imageId + '"]');
      if (matchingSwatch && matchingSwatch.getAttribute('aria-checked') !== 'true') {
        var container = matchingSwatch.closest('[data-swatch-group]');
        if (container) {
          container.querySelectorAll('.sw').forEach(function(sw) { sw.setAttribute('aria-checked', 'false'); });
        }
        matchingSwatch.setAttribute('aria-checked', 'true');

        var nameLabel = container ? container.querySelector('[data-swatch-name]') : null;
        if (nameLabel) {
          nameLabel.textContent = matchingSwatch.getAttribute('data-color');
        }

        var variantId = matchingSwatch.getAttribute('data-variant-id');
        if (variantId) {
          var variantInput = document.querySelector('input[name="id"][value="' + variantId + '"]');
          if (variantInput) {
            variantInput.checked = true;
            document.dispatchEvent(new CustomEvent('variant-change', { detail: { variantId: variantId } }));
          }
        }
      }
    });
  });

  // ── Finish colour selection from the inline script ──────────────────
  // The inline <script> in product.liquid already swapped the main image
  // and filtered thumbnails BEFORE paint. Here we just activate the swatch
  // dot, update the label, select the radio, and tag size links.
  if (window.__pendingColor) {
    var pendingColor = window.__pendingColor;
    var pendingVid = window.__pendingVariantId;

    var targetSwatch = document.querySelector('.sw[data-color="' + pendingColor + '"]');
    if (targetSwatch) {
      var swatchGroup = targetSwatch.closest('[data-swatch-group]');
      if (swatchGroup) {
        swatchGroup.querySelectorAll('.sw').forEach(function(sw) { sw.setAttribute('aria-checked', 'false'); });
        targetSwatch.setAttribute('aria-checked', 'true');
        var nameLabel = swatchGroup.querySelector('[data-swatch-name]');
        if (nameLabel) nameLabel.textContent = pendingColor;
      }
    }

    if (pendingVid) {
      var variantInput = document.querySelector('input[name="id"][value="' + pendingVid + '"]');
      if (variantInput) variantInput.checked = true;
    }

    var titleMap = { 'Ivory Black': 'Black', 'Salmon Pink': 'Pink', 'Cosmic Blue': 'Blue', 'Charcoal Grey': 'Grey' };
    updateSizeLinksWithColor(titleMap[pendingColor] || pendingColor);

    delete window.__pendingColor;
    delete window.__pendingVariantId;
  }

  // ── Mobile nav drawer ─────────────────────────────────────────────────
  var navToggle = document.getElementById('NavToggle');
  var mobileNav = document.getElementById('MobileNav');
  if (navToggle && mobileNav) {
    var openNav = function() {
      mobileNav.classList.add('open');
      document.body.classList.add('nav-open');
      navToggle.setAttribute('aria-expanded', 'true');
    };
    var closeNav = function() {
      mobileNav.classList.remove('open');
      document.body.classList.remove('nav-open');
      navToggle.setAttribute('aria-expanded', 'false');
    };
    navToggle.addEventListener('click', openNav);
    mobileNav.querySelectorAll('[data-nav-close]').forEach(function(el) { el.addEventListener('click', closeNav); });
    mobileNav.querySelectorAll('a').forEach(function(el) { el.addEventListener('click', closeNav); });
  }

  // ── PDP accordion ─────────────────────────────────────────────────────
  document.querySelectorAll('.acc-item').forEach(function(item) {
    var trigger = item.querySelector('.acc-trigger');
    var panel = item.querySelector('.acc-panel');
    if (!trigger || !panel) return;

    if (item.getAttribute('data-open') === 'true') {
      panel.style.maxHeight = 'none';
    }

    trigger.addEventListener('click', function() {
      var isOpen = item.getAttribute('data-open') === 'true';
      if (isOpen) {
        // Snapshot current height before animating to 0
        panel.style.maxHeight = panel.scrollHeight + 'px';
        // Force reflow so the browser registers the start value
        panel.offsetHeight; // eslint-disable-line no-unused-expressions
        item.setAttribute('data-open', 'false');
        panel.style.maxHeight = '0px';
      } else {
        item.setAttribute('data-open', 'true');
        panel.style.maxHeight = panel.scrollHeight + 'px';
        // After transition ends, remove fixed maxHeight so content reflows on resize
        panel.addEventListener('transitionend', function handler() {
          if (item.getAttribute('data-open') === 'true') {
            panel.style.maxHeight = 'none';
          }
          panel.removeEventListener('transitionend', handler);
        });
      }
    });
  });

  // ── Resize handler: update open accordion panels on orientation change ──
  window.addEventListener('resize', function() {
    document.querySelectorAll('.acc-item[data-open="true"] .acc-panel').forEach(function(panel) {
      panel.style.maxHeight = 'none';
    });
  });

  // ── Product carousel ──────────────────────────────────────────────────
  document.querySelectorAll('[data-carousel]').forEach(function(carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    if (!track) return;

    var section = carousel.closest('section');
    var prev = section && section.querySelector('[data-carousel-prev]');
    var next = section && section.querySelector('[data-carousel-next]');
    if (!prev || !next) return;

    var page = function() {
      var first = track.querySelector('.carousel-item');
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var step = first.getBoundingClientRect().width + gap;
      return Math.max(step, Math.floor(track.clientWidth / step) * step);
    };

    var sync = function() {
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max - 1;
    };

    prev.addEventListener('click', function() { track.scrollBy({ left: -page(), behavior: 'smooth' }); });
    next.addEventListener('click', function() { track.scrollBy({ left: page(), behavior: 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  // ── Cart quantity steppers and AJAX updates (Standalone /cart page) ─────
  window.initStandaloneCart = function() {
    document.querySelectorAll('.qty-stepper:not(.cart-drawer .qty-stepper)').forEach(function(stepper) {
      // Prevent double binding
      if (stepper.hasAttribute('data-bound')) return;
      stepper.setAttribute('data-bound', 'true');
      
      var input = stepper.querySelector('input[type="number"]');
      if (!input) return;
      stepper.querySelectorAll('button[data-step]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var step = parseInt(this.getAttribute('data-step'), 10);
          var next = Math.max(0, (parseInt(input.value, 10) || 0) + step);
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    var cartForm = document.querySelector('[data-cart-form]');
    if (cartForm) {
      if (cartForm.hasAttribute('data-bound')) return;
      cartForm.setAttribute('data-bound', 'true');

      var errorBox = document.getElementById('CartError');
      var showError = function(message) {
        if (!errorBox) return;
        errorBox.textContent = message;
        errorBox.hidden = false;
      };
      var clearError = function() {
        if (!errorBox) return;
        errorBox.hidden = true;
        errorBox.textContent = '';
      };

      var changeLine = function(lineEl, quantity) {
        var line = lineEl.getAttribute('data-line');
        lineEl.classList.add('is-updating');
        clearError();

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: Number(line), quantity: quantity })
        })
          .then(function(res) {
            return res.json().catch(function() { return {}; }).then(function(data) {
              if (!res.ok) {
                throw new Error(data.description || data.message || 'Could not update your cart. Please try again.');
              }
              window.location.reload();
            });
          })
          .catch(function(err) {
            lineEl.classList.remove('is-updating');
            var input = lineEl.querySelector('[data-qty-input]');
            if (input) input.value = input.getAttribute('data-last-qty');
            showError(err.message);
          });
      };

      cartForm.querySelectorAll('[data-cart-line]').forEach(function(lineEl) {
        var input = lineEl.querySelector('[data-qty-input]');
        var removeBtn = lineEl.querySelector('[data-remove]');
        if (!input) return;

        var debounceTimer;
        input.addEventListener('change', function() {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(function() {
            var qty = Math.max(0, parseInt(input.value, 10) || 0);
            input.value = qty;
            changeLine(lineEl, qty);
          }, 600);
        });

        if (removeBtn) {
          removeBtn.addEventListener('click', function() {
            clearTimeout(debounceTimer);
            input.value = 0;
            changeLine(lineEl, 0);
          });
        }
      });
    }
  };
  window.initStandaloneCart();

  // ── Global AJAX Add-To-Cart Form Interception ──────────────────────────
  document.addEventListener('submit', function(e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    e.preventDefault();

    var submitBtn = e.submitter || form.querySelector('button[type="submit"], input[type="submit"]');
    if (!submitBtn && form.id) {
      submitBtn = document.querySelector('button[type="submit"][form="' + form.id + '"]');
    }

    if (submitBtn) {
      submitBtn.classList.add('is-loading');
      submitBtn.disabled = true;
    }

    var formData = new FormData(form);

    CartAPI.addItem(formData)
      .then(function(addedItem) {
        return CartAPI.getCart().then(function(cart) {
          CartDrawer.render(cart);
          CartDrawer.open();

          document.dispatchEvent(new CustomEvent('cart:item-added', {
            detail: { item: addedItem, cart: cart }
          }));
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { cart: cart }
          }));
        });
      })
      .catch(function(err) {
        console.error('Cart add error:', err);
        CartDrawer.open();
        CartDrawer.showError(err.message || 'Could not add item to cart. Please try again.');
      })
      .finally(function() {
        if (submitBtn) {
          submitBtn.classList.remove('is-loading');
          submitBtn.disabled = false;
        }
      });
  });

  // ── Standalone Cart Page Sync ───────────────────────────────────────────
  // If the user opens the slide-out drawer while sitting on the standalone /cart page,
  // we must ensure the background page updates when items are deleted from the drawer.
  document.addEventListener('cart:updated', function() {
    if (typeof window !== 'undefined' && window.location && window.location.pathname === '/cart') {
      fetch('/cart')
        .then(function(res) { return res.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newCartWrap = doc.querySelector('#CartPageContent');
          var oldCartWrap = document.querySelector('#CartPageContent');
          if (newCartWrap && oldCartWrap) {
            oldCartWrap.innerHTML = newCartWrap.innerHTML;
            // Re-bind the standalone stepper events to the new DOM elements
            if (window.initStandaloneCart) window.initStandaloneCart();
          }
        });
    }
  });

  // ── Initialize Cart Drawer ─────────────────────────────────────────────
  CartDrawer.init();
});

// ── Cart API Client Service ───────────────────────────────────────────────
var CartAPI = {
  getCart: function() {
    return fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    }).then(function(res) {
      if (!res.ok) throw new Error('Failed to fetch cart');
      return res.json();
    });
  },

  addItem: function(data) {
    var isFormData = typeof FormData !== 'undefined' && data instanceof FormData;
    var fetchOptions = {
      method: 'POST',
      headers: { 'Accept': 'application/json' }
    };

    if (isFormData) {
      fetchOptions.body = data;
    } else if (typeof data === 'object') {
      fetchOptions.headers['Content-Type'] = 'application/json';
      fetchOptions.body = JSON.stringify(data);
    } else {
      fetchOptions.body = data;
    }

    return fetch('/cart/add.js', fetchOptions).then(function(res) {
      return res.json().catch(function() { return {}; }).then(function(json) {
        if (!res.ok) {
          var errorMsg = json.description || json.message || 'Could not add item to cart.';
          throw new Error(errorMsg);
        }
        return json;
      });
    });
  },

  changeItem: function(lineOrKey, quantity) {
    var body = {};
    if (typeof lineOrKey === 'number' || (!isNaN(lineOrKey) && String(lineOrKey).indexOf(':') === -1 && String(lineOrKey).length <= 4)) {
      body = { line: Number(lineOrKey), quantity: Number(quantity) };
    } else {
      body = { id: String(lineOrKey), quantity: Number(quantity) };
    }

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function(res) {
      return res.json().catch(function() { return {}; }).then(function(json) {
        if (!res.ok) {
          var errorMsg = json.description || json.message || 'Could not update cart quantity.';
          throw new Error(errorMsg);
        }
        return json;
      });
    });
  },

  formatMoney: function(cents) {
    if (typeof cents === 'string') cents = cents.replace(/[^0-9.-]+/g, '');
    var num = Number(cents) || 0;
    var amount = (num / 100).toFixed(2);
    var parts = amount.split('.');
    var intPart = parts[0];
    var decPart = parts[1];
    var sign = num < 0 ? '-' : '';
    intPart = Math.abs(parseInt(intPart, 10)).toString();

    if (intPart.length > 3) {
      var lastThree = intPart.substring(intPart.length - 3);
      var otherNumbers = intPart.substring(0, intPart.length - 3);
      var formattedOthers = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',');
      intPart = formattedOthers + ',' + lastThree;
    }
    return sign + '₹' + intPart + '.' + decPart;
  }
};
window.CartAPI = CartAPI;

// ── HTML Escaping Helper ──────────────────────────────────────────────────
function escapeCartHtml(str) {
  if (!str) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

// ── Cart Drawer Controller ────────────────────────────────────────────────
var CartDrawer = {
  drawer: null,
  scrim: null,
  panel: null,
  errorBox: null,
  itemsContainer: null,
  emptyContainer: null,
  filledContainer: null,
  footerContainer: null,
  debounceTimers: {},

  init: function() {
    this.drawer = document.getElementById('CartDrawer') || document.querySelector('[data-cart-drawer]');
    if (!this.drawer) return;

    this.scrim = this.drawer.querySelector('[data-cart-drawer-scrim]');
    this.panel = this.drawer.querySelector('.cart-drawer__panel');
    this.errorBox = this.drawer.querySelector('[data-cart-drawer-error]');
    this.itemsContainer = this.drawer.querySelector('[data-cart-drawer-items]');
    this.emptyContainer = this.drawer.querySelector('[data-cart-drawer-empty]');
    this.filledContainer = this.drawer.querySelector('[data-cart-drawer-filled]');
    this.footerContainer = this.drawer.querySelector('[data-cart-drawer-footer]');

    this.bindEvents();
    this.bindDrawerItems();
  },

  bindEvents: function() {
    var self = this;

    // Close triggers (scrim, close button, continue shopping)
    document.querySelectorAll('[data-cart-drawer-close]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        self.close();
      });
    });

    // Open triggers (header cart bag link)
    document.querySelectorAll('[data-cart-drawer-trigger]').forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        self.open();
      });
    });

    // ESC key listener
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && self.isOpen()) {
        self.close();
      }
    });

    // Custom events
    document.addEventListener('cart:open', function() { self.open(); });
    document.addEventListener('cart:close', function() { self.close(); });
    document.addEventListener('cart:refresh', function() {
      CartAPI.getCart().then(function(cart) { self.render(cart); });
    });
  },

  isOpen: function() {
    return this.drawer && this.drawer.classList.contains('is-open');
  },

  open: function() {
    if (!this.drawer) return;
    this.clearError();
    this.drawer.classList.add('is-open');
    this.drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');

    document.querySelectorAll('[data-cart-drawer-trigger]').forEach(function(el) {
      el.setAttribute('aria-expanded', 'true');
    });

    var closeBtn = this.drawer.querySelector('.cart-drawer__close');
    if (closeBtn) closeBtn.focus();
  },

  close: function() {
    if (!this.drawer) return;
    this.drawer.classList.remove('is-open');
    this.drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');

    document.querySelectorAll('[data-cart-drawer-trigger]').forEach(function(el) {
      el.setAttribute('aria-expanded', 'false');
    });
  },

  showError: function(message) {
    if (!this.errorBox) return;
    this.errorBox.textContent = message;
    this.errorBox.hidden = false;
  },

  clearError: function() {
    if (!this.errorBox) return;
    this.errorBox.hidden = true;
    this.errorBox.textContent = '';
  },

  render: function(cart) {
    if (!cart) return;
    var self = this;
    var itemCount = Number(cart.item_count) || 0;
    var totalPrice = Number(cart.total_price) || 0;
    var formattedSubtotal = CartAPI.formatMoney(totalPrice);

    // Update all item count badges across header and drawer
    document.querySelectorAll('[data-cart-count]').forEach(function(el) {
      el.textContent = itemCount;
      if (itemCount === 0) {
        el.classList.add('is-hidden');
      } else {
        el.classList.remove('is-hidden');
      }
    });

    // Update all subtotal spans
    document.querySelectorAll('[data-cart-drawer-subtotal]').forEach(function(el) {
      el.textContent = formattedSubtotal;
    });

    // Toggle Empty vs Filled States
    if (itemCount === 0) {
      if (self.emptyContainer) self.emptyContainer.classList.remove('is-hidden');
      if (self.filledContainer) self.filledContainer.classList.add('is-hidden');
      if (self.footerContainer) self.footerContainer.classList.add('is-hidden');
      if (self.itemsContainer) self.itemsContainer.innerHTML = '';
      return;
    }

    if (self.emptyContainer) self.emptyContainer.classList.add('is-hidden');
    if (self.filledContainer) self.filledContainer.classList.remove('is-hidden');
    if (self.footerContainer) self.footerContainer.classList.remove('is-hidden');

    // Build line items HTML
    if (self.itemsContainer && Array.isArray(cart.items)) {
      var html = '';
      cart.items.forEach(function(item, index) {
        var lineNum = index + 1;
        var itemKey = item.key || String(lineNum);
        var title = escapeCartHtml(item.product_title || item.title);
        var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? escapeCartHtml(item.variant_title) : '';
        var imageUrl = item.image || (item.featured_image ? (item.featured_image.url || item.featured_image) : '');
        var itemUrl = item.url || '#';
        var linePrice = CartAPI.formatMoney(item.final_line_price || (item.price * item.quantity));

        html += '<div class="cart-drawer-item" data-cart-line="' + lineNum + '" data-key="' + escapeCartHtml(itemKey) + '">';

        // Image
        html += '<a href="' + itemUrl + '" class="plate cart-drawer-item__image">';
        if (imageUrl) {
          html += '<img src="' + imageUrl + '" alt="' + title + '" loading="lazy" width="80" height="80">';
        }
        html += '</a>';

        // Details
        html += '<div class="cart-drawer-item__details">';
        html += '<div class="cart-drawer-item__header">';
        html += '<a href="' + itemUrl + '" class="cart-drawer-item__title">' + title + '</a>';
        html += '<button type="button" class="cart-remove cart-drawer-item__remove" data-remove data-line="' + lineNum + '" data-key="' + escapeCartHtml(itemKey) + '" aria-label="Remove ' + title + ' from cart">';
        html += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>';
        html += '</button>';
        html += '</div>';

        if (variantTitle) {
          html += '<p class="cart-drawer-item__variant">' + variantTitle + '</p>';
        }

        // Stepper + Price
        html += '<div class="cart-drawer-item__footer">';
        html += '<div class="qty-stepper" data-line="' + lineNum + '" data-key="' + escapeCartHtml(itemKey) + '">';
        html += '<button type="button" data-step="-1" aria-label="Decrease quantity"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"/></svg></button>';
        html += '<input type="number" name="updates[]" value="' + item.quantity + '" min="0" data-qty-input data-line="' + lineNum + '" data-key="' + escapeCartHtml(itemKey) + '" data-last-qty="' + item.quantity + '" aria-label="Quantity for ' + title + '">';
        html += '<button type="button" data-step="1" aria-label="Increase quantity"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></button>';
        html += '</div>';
        html += '<div class="cart-drawer-item__price">' + linePrice + '</div>';
        html += '</div>';

        html += '</div>'; // details
        html += '</div>'; // item
      });

      self.itemsContainer.innerHTML = html;
      self.bindDrawerItems();
    }
  },

  bindDrawerItems: function() {
    var self = this;
    if (!self.drawer) return;

    // Stepper +/- buttons
    self.drawer.querySelectorAll('.qty-stepper').forEach(function(stepper) {
      var input = stepper.querySelector('input[data-qty-input]');
      if (!input) return;

      stepper.querySelectorAll('button[data-step]').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          var step = parseInt(this.getAttribute('data-step'), 10) || 0;
          var current = parseInt(input.value, 10) || 0;
          var next = Math.max(0, current + step);
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    // Line quantity changes and removals
    self.drawer.querySelectorAll('.cart-drawer-item').forEach(function(itemEl) {
      var key = itemEl.getAttribute('data-key') || itemEl.getAttribute('data-line');
      var input = itemEl.querySelector('input[data-qty-input]');
      var removeBtn = itemEl.querySelector('[data-remove]');

      var handleQuantityChange = function(newQty) {
        itemEl.classList.add('is-updating');
        self.clearError();

        CartAPI.changeItem(key, newQty)
          .then(function(updatedCart) {
            self.render(updatedCart);
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: { cart: updatedCart }
            }));
          })
          .catch(function(err) {
            itemEl.classList.remove('is-updating');
            if (input) input.value = input.getAttribute('data-last-qty') || 1;
            self.showError(err.message || 'Could not update quantity. Maximum available stock reached.');
          });
      };

      if (input) {
        input.addEventListener('change', function() {
          var targetQty = Math.max(0, parseInt(input.value, 10) || 0);
          input.value = targetQty;
          clearTimeout(self.debounceTimers[key]);
          self.debounceTimers[key] = setTimeout(function() {
            handleQuantityChange(targetQty);
          }, 350);
        });
      }

      if (removeBtn) {
        removeBtn.addEventListener('click', function(e) {
          e.preventDefault();
          clearTimeout(self.debounceTimers[key]);
          handleQuantityChange(0);
        });
      }
    });
  }
};
window.CartDrawer = CartDrawer;

// ==========================================================================
// Hero Banner Carousel Controller (M1)
// ==========================================================================
function HeroCarousel(container) {
  if (!container) return;
  this.container = container;
  this.carousel = container.querySelector('.hero-carousel') || container;
  this.track = container.querySelector('.hero-carousel__track');
  this.slides = Array.from(container.querySelectorAll('.hero-slide'));
  this.prevBtn = container.querySelector('.hero-carousel__arrow--prev');
  this.nextBtn = container.querySelector('.hero-carousel__arrow--next');
  this.dots = Array.from(container.querySelectorAll('.hero-carousel__dot'));

  this.autoplay = container.getAttribute('data-autoplay') === 'true';
  this.autoplayInterval = parseInt(container.getAttribute('data-interval'), 10) || 5000;
  this.transitionSpeed = parseInt(container.getAttribute('data-speed'), 10) || 600;
  this.transitionEffect = container.getAttribute('data-transition') || 'slide';
  this.pauseOnHover = container.getAttribute('data-pause-on-hover') !== 'false';

  this.currentIndex = 0;
  this.timer = null;
  this.isPaused = false;
  this.isDragging = false;
  this.isSwiping = null; // null: undecided, true: horizontal, false: vertical
  this.startX = 0;
  this.startY = 0;
  this.currentX = 0;
  this.currentY = 0;
  this.startTime = 0;

  this.init();
}

HeroCarousel.prototype = {
  init: function() {
    if (!this.track || this.slides.length === 0) return;

    // If only 1 slide, hide controls and ensure clean state
    if (this.slides.length <= 1) {
      if (this.prevBtn) this.prevBtn.style.display = 'none';
      if (this.nextBtn) this.nextBtn.style.display = 'none';
      this.dots.forEach(function(dot) { dot.style.display = 'none'; });
      this.goToSlide(0, false);
      return;
    }

    this.bindEvents();
    this.goToSlide(0, false);

    if (this.autoplay) {
      this.startAutoplay();
    }
  },

  goToSlide: function(index, animate) {
    if (this.slides.length === 0) return;
    var total = this.slides.length;
    var nextIndex = ((index % total) + total) % total;
    this.currentIndex = nextIndex;

    // Track translation
    if (this.transitionEffect === 'slide' && this.track) {
      if (animate === false) {
        this.track.style.transition = 'none';
        this.track.style.transform = 'translate3d(' + (-this.currentIndex * 100) + '%, 0, 0)';
        // Force reflow
        this.track.offsetHeight;
        this.track.style.transition = '';
      } else {
        this.track.style.transform = 'translate3d(' + (-this.currentIndex * 100) + '%, 0, 0)';
      }
    }

    // Update slides
    var self = this;
    this.slides.forEach(function(slide, i) {
      var isActive = (i === self.currentIndex);
      if (isActive) {
        slide.classList.add('is-active');
        slide.removeAttribute('aria-hidden');
        slide.removeAttribute('inert');
        slide.querySelectorAll('a, button').forEach(function(el) {
          el.removeAttribute('tabindex');
        });
        // Play video if present
        var video = slide.querySelector('video');
        if (video) {
          try {
            var playPromise = video.play();
            if (playPromise !== undefined) {
              playPromise.catch(function() {});
            }
          } catch (e) {}
        }
      } else {
        slide.classList.remove('is-active');
        slide.setAttribute('aria-hidden', 'true');
        slide.setAttribute('inert', '');
        slide.querySelectorAll('a, button').forEach(function(el) {
          el.setAttribute('tabindex', '-1');
        });
        // Pause video if present
        var video = slide.querySelector('video');
        if (video) {
          try {
            video.pause();
          } catch (e) {}
        }
      }
    });

    // Update dots
    this.dots.forEach(function(dot, i) {
      var isActive = (i === self.currentIndex);
      if (isActive) {
        dot.classList.add('is-active');
        dot.setAttribute('aria-selected', 'true');
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.classList.remove('is-active');
        dot.setAttribute('aria-selected', 'false');
        dot.setAttribute('aria-current', 'false');
      }
    });
  },

  nextSlide: function() {
    this.goToSlide(this.currentIndex + 1);
  },

  prevSlide: function() {
    this.goToSlide(this.currentIndex - 1);
  },

  startAutoplay: function() {
    this.stopAutoplay();
    if (!this.autoplay || this.slides.length <= 1 || this.isPaused) return;

    var self = this;
    this.timer = setInterval(function() {
      self.nextSlide();
    }, this.autoplayInterval);
  },

  stopAutoplay: function() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },

  pause: function() {
    this.isPaused = true;
    this.stopAutoplay();
  },

  resume: function() {
    this.isPaused = false;
    if (this.autoplay) {
      this.startAutoplay();
    }
  },

  bindEvents: function() {
    var self = this;

    // Arrow navigation
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        self.prevSlide();
        if (self.autoplay && !self.isPaused) self.startAutoplay();
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        self.nextSlide();
        if (self.autoplay && !self.isPaused) self.startAutoplay();
      });
    }

    // Dot navigation
    this.dots.forEach(function(dot, idx) {
      dot.addEventListener('click', function(e) {
        e.preventDefault();
        self.goToSlide(idx);
        if (self.autoplay && !self.isPaused) self.startAutoplay();
      });
    });

    // Pause on hover
    if (this.pauseOnHover) {
      this.container.addEventListener('pointerenter', function() {
        self.pause();
      });

      this.container.addEventListener('pointerleave', function() {
        self.resume();
      });
    }

    // Pause on focus within
    this.container.addEventListener('focusin', function() {
      self.pause();
    });

    this.container.addEventListener('focusout', function(e) {
      if (!self.container.contains(e.relatedTarget)) {
        self.resume();
      }
    });

    // Pause when tab is inactive
    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        self.pause();
      } else {
        self.resume();
      }
    });

    // Keyboard navigation
    this.container.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        self.prevSlide();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        self.nextSlide();
      } else if (e.key === 'Home') {
        e.preventDefault();
        self.goToSlide(0);
      } else if (e.key === 'End') {
        e.preventDefault();
        self.goToSlide(self.slides.length - 1);
      }
    });

    // Touch & Pointer Drag Gestures (1:1 tracking)
    var onDragStart = function(e) {
      if (e.button && e.button !== 0) return; // Only left click for pointer events
      var point = e.touches ? e.touches[0] : e;
      self.isDragging = true;
      self.isSwiping = null;
      self.startX = point.clientX;
      self.startY = point.clientY;
      self.currentX = point.clientX;
      self.currentY = point.clientY;
      self.startTime = Date.now();
      self.carousel.classList.add('is-dragging');
      self.stopAutoplay();
    };

    var onDragMove = function(e) {
      if (!self.isDragging) return;
      var point = e.touches ? e.touches[0] : e;
      self.currentX = point.clientX;
      self.currentY = point.clientY;

      var dx = self.currentX - self.startX;
      var dy = self.currentY - self.startY;

      // Determine gesture direction on initial movement
      if (self.isSwiping === null) {
        if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 6) {
          self.isSwiping = false; // Vertical scroll, disengage
        } else if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 6) {
          self.isSwiping = true; // Horizontal swipe
        }
      }

      if (self.isSwiping === true) {
        if (e.cancelable) e.preventDefault();
        var width = self.carousel.offsetWidth || 1;
        var offsetPercent = -self.currentIndex * 100;
        var dragPercent = (dx / width) * 100;
        self.track.style.transform = 'translate3d(' + (offsetPercent + dragPercent) + '%, 0, 0)';
      }
    };

    var onDragEnd = function(e) {
      if (!self.isDragging) return;
      self.isDragging = false;
      self.carousel.classList.remove('is-dragging');
      self.track.style.transition = '';

      if (self.isSwiping === true) {
        var dx = self.currentX - self.startX;
        var dt = Date.now() - self.startTime;
        var velocity = Math.abs(dx) / (dt || 1);

        if (Math.abs(dx) > 40 || velocity > 0.35) {
          if (dx < 0) {
            self.nextSlide();
          } else {
            self.prevSlide();
          }
        } else {
          // Snap back
          self.goToSlide(self.currentIndex);
        }
      } else {
        self.goToSlide(self.currentIndex);
      }

      self.isSwiping = null;
      if (self.autoplay && !self.isPaused) {
        self.startAutoplay();
      }
    };

    // Attach touch handlers to carousel
    this.carousel.addEventListener('touchstart', onDragStart, { passive: true });
    this.carousel.addEventListener('touchmove', onDragMove, { passive: false });
    this.carousel.addEventListener('touchend', onDragEnd, { passive: true });
    this.carousel.addEventListener('touchcancel', onDragEnd, { passive: true });

    // Attach pointer handlers for desktop mouse drag
    this.carousel.addEventListener('pointerdown', onDragStart);
    window.addEventListener('pointermove', onDragMove);
    window.addEventListener('pointerup', onDragEnd);
    window.addEventListener('pointercancel', onDragEnd);
  },

  destroy: function() {
    this.stopAutoplay();
  }
};

window.HeroCarousel = HeroCarousel;

// Auto-initialize all hero carousels on page
function initHeroCarousels() {
  document.querySelectorAll('[data-hero-carousel]').forEach(function(el) {
    if (!el._heroCarousel) {
      el._heroCarousel = new HeroCarousel(el);
    }
  });
}

window.initHeroCarousels = initHeroCarousels;

// Initialize on DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeroCarousels);
} else {
  initHeroCarousels();
}

// Shopify Theme Editor Integration
document.addEventListener('shopify:section:load', function(e) {
  var section = e.target;
  var hero = section.querySelector('[data-hero-carousel]') || (section.matches && section.matches('[data-hero-carousel]') ? section : null);
  if (hero) {
    if (hero._heroCarousel) hero._heroCarousel.destroy();
    hero._heroCarousel = new HeroCarousel(hero);
  }
});

document.addEventListener('shopify:section:unload', function(e) {
  var section = e.target;
  var hero = section.querySelector('[data-hero-carousel]') || (section.matches && section.matches('[data-hero-carousel]') ? section : null);
  if (hero && hero._heroCarousel) {
    hero._heroCarousel.destroy();
    hero._heroCarousel = null;
  }
});

document.addEventListener('shopify:block:select', function(e) {
  var blockId = e.detail && e.detail.blockId;
  if (!blockId) return;
  var blockEl = document.querySelector('[data-block-id="' + blockId + '"]');
  if (blockEl) {
    var heroEl = blockEl.closest('[data-hero-carousel]');
    if (heroEl && heroEl._heroCarousel) {
      var slideIndex = parseInt(blockEl.getAttribute('data-slide-index'), 10);
      if (!isNaN(slideIndex)) {
        heroEl._heroCarousel.goToSlide(slideIndex);
        heroEl._heroCarousel.pause();
      }
    }
  }
});

document.addEventListener('shopify:block:deselect', function(e) {
  var blockId = e.detail && e.detail.blockId;
  if (!blockId) return;
  var blockEl = document.querySelector('[data-block-id="' + blockId + '"]');
  if (blockEl) {
    var heroEl = blockEl.closest('[data-hero-carousel]');
    if (heroEl && heroEl._heroCarousel) {
      heroEl._heroCarousel.resume();
    }
  }
});

